import { thicknessEquivalence, } from "./wsi4_typeguards";
export function thicknessConfig(shopConfig, bendPart, value, i18n) {
    const entries = bendPart ? shopConfig.minLowerDieOpeningWidths.map(x => x.thickness) : shopConfig.allowedCuttingGasConfigurations.map(x => x.thickness);
    if (value !== undefined) {
        entries.push(value);
    }
    const thicknesses = entries.reduce((arr, entry) => {
        if (!arr.some(t => thicknessEquivalence(t, entry))) {
            arr.push(entry);
        }
        return arr;
    }, []);
    thicknesses.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
    return thicknesses.map((x) => ({
        name: i18n.numberWithTwoDecimals(x),
        value: i18n.numberWithTwoDecimals(x),
        number: x,
        invalid: undefined,
    }));
}
